import axios from 'axios'
let environment = '';
if (process.env.NODE_ENV == 'development') {
  environment = 'http://localhost:8100/api/'
}
if (process.env.NODE_ENV == 'production') {
  environment = 'https://api.konspektypilkanozna.pl/api/'
}

export default () => {
  return axios.create({
    baseURL: environment,
  })
}